import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

/**
 * Outcome of an origin connection test
 */
export interface ConnectionTestOutcome {
  originName: string;
  success: boolean;
  responseTimeMs?: number;
  error?: string;
}

export interface ConnectionTestModalProps {
  /** Outcome to show; the modal is open while it is set */
  outcome: ConnectionTestOutcome | null;
  onClose: () => void;
}

/**
 * Result of testing the connection to an origin group
 */
export function ConnectionTestModal({ outcome, onClose }: ConnectionTestModalProps) {
  return (
    <Modal
      isOpen={outcome !== null}
      onClose={onClose}
      size="sm"
      title="Connection Test Result"
      footer={<Button onClick={onClose}>Close</Button>}
    >
      {outcome && (
        <div className="origin-groups-test-result">
          <p>
            <strong>Origin:</strong> {outcome.originName}
          </p>
          <p>
            <strong>Status:</strong>{' '}
            <span className={outcome.success ? 'test-success' : 'test-failure'}>
              {outcome.success ? 'Success' : 'Failed'}
            </span>
          </p>
          {outcome.responseTimeMs !== undefined && (
            <p>
              <strong>Response Time:</strong> {outcome.responseTimeMs}ms
            </p>
          )}
          {outcome.error && (
            <p>
              <strong>Error:</strong> {outcome.error}
            </p>
          )}
        </div>
      )}
    </Modal>
  );
}
